import {action, computed, observable} from 'mobx';
import ModuleStore from 'store/modules/ModuleStore';

class ShopHackStore extends ModuleStore {
    @observable prices;

    @observable form = {
        order: [],
        totalPrice: null
    }

    @observable products =[];

    constructor(rootStore) {
        super(rootStore);
        this.rootStore = rootStore;
    }

    @computed
    get createShopHackPaymentPromise() {
        return () => {
            return new Promise((resolve, reject) => {
                resolve();
            })
        }
    }

    @action
    setProducts(products) {
        // Ensure the products array and its contents are observable
        this.products = observable(products);
    }

    @action
    setFormValue(formField, value) {
        if (formField !== 'totalPrice' && formField !== 'order') {
            this.products[Number(formField)].quantity = value;
            console.log('Updated product quantity:', this.products[Number(formField)]);
        } else {
            this.form[formField] = value;
        }
    }

}

export default ShopHackStore;
